var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "list_once" }, [
      _c("p", { staticClass: "p" }, [_vm._v("如何将印章授权给成员使用")]),
      _c("p", { staticClass: "text" }, [
        _vm._v("1.在首页中点击“企业控制台”进入企业管理界面；")
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img16.png", alt: "" }
      }),
      _c("p", { staticClass: "text" }, [
        _vm._v(
          "2.点击“印章及授权”，进入企业印章页面，点击印章下“添加用印审批流程”按钮；"
        )
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img17.png", alt: "" }
      }),
      _c("p", { staticClass: "text" }, [
        _vm._v(
          "3.选择需要关联的审批流程，点击确认。（为创建审批流程时，点击用印审批设置菜单入口即可去创建、管理用印审批流程）"
        )
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img18.png", alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f205066", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f205066","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dingtalkUse/helpCenterCom/6_menberUse.vue
// module id = gJHh
// module chunks = 54 237